export function addLinkAccessed(linkAccessed) {
  return {
    type: '@system/ADD_LINK_ACCESSED',
    linkAccessed,
  };
}

export function addLastOrderId(lastOrderId) {
  return {
    type: '@system/ADD_LAST_ORDER_ID',
    lastOrderId,
  };
}

export function setWhatsappOrderBlock(blocked, reason) {
  return {
    type: '@system/SET_WHATSAPP_ORDER_BLOCK',
    blocked: !!blocked,
    reason: reason || '',
  };
}
